import gql from 'graphql-tag';

export const recordNotificationEngagement = gql(/* GraphQL */ `
  mutation RecordNotificationEngagement($notificationIntentId: UUID!) {
    recordNotificationEngagement(notificationIntentId: $notificationIntentId) {
      id
      engagedAts
    }
  }
`);
